import RealtimeWorkflowDetail from '@/features/Workflow/WorkflowDetail/realtime/RealtimeWorkflowDetail';

const CreateRealtimeNotificationPage = () => {
  return <RealtimeWorkflowDetail mode="CREATE" />;
};

export default CreateRealtimeNotificationPage;
